import { createAsyncThunk } from '@reduxjs/toolkit';
import * as reportApi from '../../api/reportsapi';

export const getReports = createAsyncThunk('getReportsList', async (data) => {
    const res = await reportApi.getReportList({ data: data });
    return res.data;
});
